import { Card } from 'antd';

import { useAiAgents, useAiAgentsEffects } from '@pages/AiAgents/hooks';
import { AiChatLayout } from '@pages/AiAgents/ui';

import type { FC } from 'react';

import '@pages/AiAgents/styles/AiAgents.desktop.scss';

export const AiAgents: FC = () => {
  const {
    messages,
    isChatLoading,
    isMessagesLoading,
    isSending,
    inputValue,
    isInputDisabled,
    handleInputChange,
    handleSendMessage,
    messagesContainerRef,
    scrollToBottom,
    markMessagesAsRead,
    connectWs,
    disconnectWs,
    isResetting,
    onReset,
  } = useAiAgents();

  useAiAgentsEffects({
    scrollToBottom,
    markMessagesAsRead,
    connectWs,
    disconnectWs,
  });

  return (
    <div className="ai-agents-page">
      <Card className="ai-agents-card" variant="borderless">
        <AiChatLayout
          messages={messages}
          isChatLoading={isChatLoading}
          isMessagesLoading={isMessagesLoading}
          isSending={isSending}
          inputValue={inputValue}
          isInputDisabled={isInputDisabled}
          onInputChange={handleInputChange}
          onSend={handleSendMessage}
          messagesContainerRef={messagesContainerRef}
          isResetting={isResetting}
          onReset={onReset}
        />
      </Card>
    </div>
  );
};
